export default function setButtonColor({ borderColor, color }) {
    document.documentElement.style.setProperty('--borderColor', borderColor);
    document.documentElement.style.setProperty('--color', color);
}